var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 789,
    height: 789,
    viewBox: "0 0 789 789",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6203_97154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M282.917 773.026L282.409 772.121L15.9688 282.923L506.072 15.974L506.581 16.8787L773.021 506.077L282.917 773.026ZM18.796 283.743L283.737 770.199L770.194 505.258L505.252 18.8012L18.796 283.743Z",
    fill: "url(#paint0_linear_6203_97154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.214 768.559L20.4414 520.214L20.8938 519.281L268.787 20.441L768.559 268.815L768.107 269.748L520.214 768.587V768.559ZM23.2121 519.281L519.253 765.788L765.76 269.748L269.72 23.2117L23.2121 519.281Z",
    fill: "url(#paint1_linear_6203_97154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.19 712.042L160.049 711.024L76.9844 160.192L628.835 76.986L629.004 78.0038L712.069 628.808L160.219 712.014L160.19 712.042ZM79.331 161.945L161.915 709.667L709.638 627.083L627.054 79.3609L79.331 161.945Z",
    fill: "url(#paint2_linear_6203_97154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.675 789L383.969 788.237L0 384.675L404.325 0L405.031 0.763357L789 404.325L384.675 789ZM2.94034 384.76L384.76 786.06L786.06 404.24L404.24 2.94034L2.94034 384.76Z",
    fill: "url(#paint3_linear_6203_97154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.743 723.295L65.6992 612.749L176.245 65.7052L723.26 176.251L612.715 723.266L612.743 723.295ZM68.1589 611.109L611.103 720.835L720.829 177.89L177.884 68.1649L68.1589 611.109Z",
    fill: "url(#paint4_linear_6203_97154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.356 761.858L249.932 760.897L27.1445 250.353L538.65 27.1415L539.074 28.1027L761.861 538.647L250.356 761.858ZM29.887 251.427L251.43 759.116L759.119 537.573L537.576 29.8839L29.887 251.427Z",
    fill: "url(#paint5_linear_6203_97154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.136 778.115L486.259 777.578L10.9141 487.135L301.866 10.9131L302.743 11.4503L778.088 301.893L487.107 778.115H487.136ZM13.7696 486.428L486.457 775.231L775.26 302.544L302.573 13.7686L13.7696 486.428Z",
    fill: "url(#paint6_linear_6203_97154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.417 690.414L98.6133 133.418L655.609 98.6144L690.413 655.61L133.417 690.414ZM100.819 135.34L135.368 688.18L688.207 653.631L653.659 100.791L100.819 135.34Z",
    fill: "url(#paint7_linear_6203_97154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.346 786.653L349.695 785.833L2.33984 350.352L3.15975 349.702L438.641 2.34656L439.291 3.16646L786.618 438.647L785.798 439.298L350.317 786.625L350.346 786.653ZM5.28018 350.663L350.685 783.713L783.735 438.308L438.33 5.2869L5.28018 350.663Z",
    fill: "url(#paint8_linear_6203_97154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.264 741.05L582.275 740.767L47.9531 583.261L48.2359 582.271L205.742 47.95L206.731 48.2327L741.053 205.739L740.77 206.728L583.264 741.05ZM50.5259 581.847L581.851 738.477L738.48 207.152L207.155 50.5228L50.5259 581.847Z",
    fill: "url(#paint9_linear_6203_97154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.883 747.892L218.544 746.902L41.1055 218.886L42.095 218.546L570.112 41.1083L570.451 42.0978L747.889 570.115L746.9 570.454L218.883 747.892ZM43.7348 220.186L220.183 745.263L745.26 568.814L568.811 43.7376L43.7348 220.186Z",
    fill: "url(#paint10_linear_6203_97154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.349 784.703L4.29688 453.349L335.65 4.29749L784.702 335.679L453.32 784.731L453.349 784.703ZM7.20894 452.897L452.924 781.791L781.818 336.075L336.103 7.20955L7.20894 452.897Z",
    fill: "url(#paint11_linear_6203_97154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M666.53 680.406L108.629 666.524V665.478L122.511 108.595L680.411 122.477V123.523L666.53 680.406ZM110.749 664.488L664.494 678.257L678.263 124.512L124.518 110.743L110.749 664.488Z",
    fill: "url(#paint12_linear_6203_97154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.338 781.31L7.6875 316.341L472.657 7.68994L781.279 472.659L316.31 781.281L316.338 781.31ZM10.5713 316.906L316.904 778.426L778.423 472.094L472.091 10.5737L10.5713 316.906Z",
    fill: "url(#paint13_linear_6203_97154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.331 756.176L551.37 755.808L32.8242 552.331L236.669 32.8243L237.63 33.1919L756.175 236.669L552.331 756.176ZM35.5101 551.144L551.172 753.49L753.518 237.828L237.856 35.5102L35.5101 551.144Z",
    fill: "url(#paint14_linear_6203_97154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.744 731.24L188.49 730.222L57.7578 188.747L600.25 57.7609L600.505 58.7787L731.265 600.253L188.772 731.24H188.744ZM60.2741 190.274L190.299 728.723L728.748 598.698L598.723 60.2771L60.2741 190.274Z",
    fill: "url(#paint15_linear_6203_97154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.113 788.35L418.322 787.671L0.652344 419.111L1.33088 418.319L369.891 0.650146L370.683 1.32869L788.38 369.889L787.701 370.68L419.142 788.378L419.113 788.35ZM3.59268 418.913L418.944 785.409L785.44 370.058L370.089 3.59048L3.59268 418.913Z",
    fill: "url(#paint16_linear_6203_97154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640.576 703.023L86.0117 640.57L86.1248 639.523L148.437 85.9767L703.002 148.431L702.889 149.477L640.548 703.023H640.576ZM88.3018 638.732L638.739 700.705L700.712 150.268L150.275 88.295L88.3018 638.732Z",
    fill: "url(#paint17_linear_6203_97154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.917 773.026L282.409 772.121L15.9688 282.923L506.072 15.974L506.581 16.8787L773.021 506.077L282.917 773.026ZM18.796 283.743L283.737 770.199L770.194 505.258L505.252 18.8012L18.796 283.743Z",
    fill: "url(#paint18_linear_6203_97154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.214 768.559L20.4414 520.214L20.8938 519.281L268.787 20.441L768.559 268.815L768.107 269.748L520.214 768.587V768.559ZM23.2121 519.281L519.253 765.788L765.76 269.748L269.72 23.2117L23.2121 519.281Z",
    fill: "url(#paint19_linear_6203_97154)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.19 712.042L160.049 711.024L76.9844 160.192L628.835 76.986L629.004 78.0038L712.069 628.808L160.219 712.014L160.19 712.042ZM79.331 161.945L161.915 709.667L709.638 627.083L627.054 79.3609L79.331 161.945Z",
    fill: "url(#paint20_linear_6203_97154)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6203_97154",
    x1: 15.9688,
    y1: 394.514,
    x2: 773.021,
    y2: 394.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B4F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6203_97154",
    x1: 20.4414,
    y1: 394.514,
    x2: 768.559,
    y2: 394.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B4F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6203_97154",
    x1: 76.9844,
    y1: 394.514,
    x2: 712.041,
    y2: 394.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B4F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6203_97154",
    x1: 0,
    y1: 0,
    x2: 789,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B4F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6203_97154",
    x1: 65.6992,
    y1: 394.514,
    x2: 723.289,
    y2: 394.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B4F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6203_97154",
    x1: 27.1445,
    y1: 394.514,
    x2: 761.861,
    y2: 394.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B4F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6203_97154",
    x1: 10.9141,
    y1: 394.514,
    x2: 778.116,
    y2: 394.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B4F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6203_97154",
    x1: 98.6133,
    y1: 394.514,
    x2: 690.413,
    y2: 394.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B4F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6203_97154",
    x1: 2.33984,
    y1: 394.514,
    x2: 786.647,
    y2: 394.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B4F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6203_97154",
    x1: 47.9531,
    y1: 394.514,
    x2: 741.053,
    y2: 394.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B4F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6203_97154",
    x1: 41.1055,
    y1: 394.514,
    x2: 747.889,
    y2: 394.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B4F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6203_97154",
    x1: 4.29688,
    y1: 394.514,
    x2: 784.702,
    y2: 394.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B4F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6203_97154",
    x1: 108.601,
    y1: 394.514,
    x2: 680.411,
    y2: 394.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B4F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_6203_97154",
    x1: 7.6875,
    y1: 394.514,
    x2: 781.307,
    y2: 394.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B4F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_6203_97154",
    x1: 32.8242,
    y1: 394.514,
    x2: 756.175,
    y2: 394.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B4F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_6203_97154",
    x1: 57.7578,
    y1: 394.514,
    x2: 731.236,
    y2: 394.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B4F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_6203_97154",
    x1: 0.652344,
    y1: 394.514,
    x2: 788.352,
    y2: 394.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B4F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_6203_97154",
    x1: 85.9834,
    y1: 394.514,
    x2: 703.03,
    y2: 394.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B4F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_6203_97154",
    x1: 15.9688,
    y1: 394.514,
    x2: 773.021,
    y2: 394.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B4F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_6203_97154",
    x1: 20.4414,
    y1: 394.514,
    x2: 768.559,
    y2: 394.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B4F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_6203_97154",
    x1: 76.9844,
    y1: 394.514,
    x2: 712.041,
    y2: 394.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A4D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B4F7FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6FBFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6203_97154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 789,
    height: 789,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/BG.4d041d5302c84839de5fa3fae3dec296.svg";
export { ForwardRef as ReactComponent };